// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { CircularProgress, Paper, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import cx from 'classnames'
import get from 'lodash/get'
import React from 'react'
import { Query } from 'react-apollo'
import { removeTypename } from '../../../common/utils'
import withUser from '../../auth/withUser'
import { i18n } from '../../index'
import ImageOverlay from '../ImageOverlay/ImageOverlay'
import MonthlyInfoPage from '../MonthlyInfoPage'
import RequiresAction from '../RequiresAction'
import SalesAndHours from '../SalesAndHours'
import Images from '../components/Images'
import Links from '../components/Links'
import { fetchManagerPageScoreCardStats, fetchMonthlyInfoScoreCard } from '../monthlyInfoQueries'
import css from './managerPage.css'

const ScoreCardTable = ({ stationId, date }) => {
  return (
    <Query
      query={fetchManagerPageScoreCardStats}
      variables={{
        stationId,
      }}
    >
      {({ loading, error, data }) => {
        if (loading || error) {
          return <CircularProgress />
        }

        return (
          <Paper className={css.scoreCard}>
            <Table size='small' className={css.table}>
              <TableHead>
                <TableRow>
                  <TableCell className={css.tableHeading}>{i18n.t('scoreCard.columnHeaderName')}</TableCell>
                  <TableCell className={css.tableHeading}>{i18n.t('scoreCard.columnHeaderRollingYear')}</TableCell>
                  <TableCell className={css.tableHeading}>{i18n.t('scoreCard.columnHeaderLastMonth')}</TableCell>
                  <TableCell className={css.tableHeading}>{i18n.t('scoreCard.columnHeaderThisMonth')}</TableCell>
                  <TableCell className={cx(css.tableHeading, css.actionCell)}>
                    {i18n.t('monthlyInfo.heading.isActionRequired')}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Object.entries(removeTypename(data.scoreCardStats)).map((row: any, i: number) => {
                  const [category, values] = row
                  const { rollingYear, lastMonth, thisMonth } = values || {}

                  return (
                    <TableRow key={i}>
                      <TableCell className={css.tableCell}>{i18n.t(`scoreCard.${category}`)}</TableCell>
                      <TableCell className={css.tableCell}>
                        <div className={css.cellValue}>
                          <span className={cx(css.colorCircle)} />
                          {rollingYear.actual}
                        </div>
                      </TableCell>
                      <TableCell className={css.tableCell}>
                        <div className={css.cellValue}>
                          <span className={cx(css.colorCircle)} />
                          {lastMonth.actual}
                        </div>
                      </TableCell>
                      <TableCell className={css.tableCell}>
                        {values.thisMonth && (
                          <div className={css.cellValue}>
                            <span className={cx(css.colorCircle)} />
                            {thisMonth.actual}
                          </div>
                        )}
                      </TableCell>
                      <TableCell className={css.actionCell}>
                        <Query
                          query={fetchMonthlyInfoScoreCard}
                          variables={{
                            stationId,
                            date,
                            type: 'ScoreCard',
                            row: `manager_${category}`,
                          }}
                        >
                          {({ loading, error, data, refetch }) => {
                            if (loading || error) {
                              return <CircularProgress />
                            }

                            const info = get(data, 'monthlyInfo.0', {})
                            return (
                              <RequiresAction
                                stationId={stationId}
                                date={date}
                                subject='Management'
                                isActionRequired={info.isActionRequired}
                                monthlyInfoId={info.id}
                                refetch={refetch}
                              />
                            )
                          }}
                        </Query>
                      </TableCell>
                    </TableRow>
                  )
                })}
              </TableBody>
            </Table>
          </Paper>
        )
      }}
    </Query>
  )
}

@withUser
class ManagerPage extends React.Component {
  constructor() {
    super()
    this.state = {
      imageOverlayIsOpen: false,
      selectedImage: null,
    }
  }

  selectImage = (imageContent: string) => {
    this.setState({
      selectedImage: imageContent,
      imageOverlayIsOpen: true,
    })
  }

  render() {
    const { imageOverlayIsOpen, selectedImage } = this.state
    const { user } = this.props
    return (
      <MonthlyInfoPage className={css.component} subject='Management'>
        {({ stationId, date, dateFormat, onDateChange, companyId }) => (
          <div className={css.content}>
            <ImageOverlay
              isOpen={imageOverlayIsOpen}
              image={selectedImage}
              onClose={() =>
                this.setState({
                  selectedImage: null,
                  imageOverlayIsOpen: false,
                })
              }
            />

            <SalesAndHours stationId={stationId} date={date} />

            <ScoreCardTable stationId={stationId} date={date} />

            <Images
              stationId={stationId}
              selectImage={this.selectImage}
              user={user}
              imageType={'monthlyinfo_manager'}
            />

            <Links stationId={stationId} linkType={'monthlyinfo_manager'} companyId={companyId} />
          </div>
        )}
      </MonthlyInfoPage>
    )
  }
}

export default ManagerPage
